module.exports = __webpack_public_path__ + "img/page1-1.225fef0a.png";